export default "__VITE_ASSET__BVyGVSok__"